import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {z} from 'zod';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {ProductCardScratchpadState} from '../../scratchpad/productCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';
import feedsApi from 'common/src/modules/feeds/feeds.api';

const searchFeedColumnsToolSchema = z.object({});

export default function searchFeedColumnsTool() {
  async function execute({
    toolUtils: {agentScratchpad},
  }: ToolExecuteParams<
    typeof searchFeedColumnsToolSchema,
    ProductCardScratchpadState
  >): Promise<ToolResult> {
    const validatedScratchpad = validateAgentScratchpad<ProductCardScratchpadState>(
      agentScratchpad,
      NodeType.PRODUCTS,
    );

    if (!validatedScratchpad.card.feedId) {
      return toolError('No feed ID found, you need to set a feed first');
    }

    const signals = await feedsApi.getSupportedSignals(validatedScratchpad.card.feedId);
    validatedScratchpad.card.availableFeedColumns = signals;

    return toolResult(JSON.stringify({columns: validatedScratchpad.card.availableFeedColumns}));
  }

  return tool({
    name: V2CardAgentToolName.SearchFeedColumns,
    displayName: 'Searching for feed columns',
    description:
      'Search for available feed columns for product matching conditions. Only relevant for Product Matching strategies.',
    execute,
    inputSchema: searchFeedColumnsToolSchema,
  });
}
